(() => {
  const root = document.querySelector('[data-jm-root]');
  if (!root) return;
  const variants = [...root.querySelectorAll('[data-jm-variant]')];
  const select = root.querySelector('[data-jm-select]');
  const current = root.querySelector('[data-jm-current]');
  const stock = root.querySelector('[data-jm-stock]');
  const productImage = root.querySelector('[data-jm-product-image]');
  const productLabel = root.querySelector('[data-jm-product-label]');
  const addButtons = [...root.querySelectorAll('[data-jm-add]')];
  const setVariant = (id, title, available) => {
    root.dataset.variantId = id;
    variants.forEach((button) => button.classList.toggle('is-active', button.dataset.id === String(id)));
    if (select) select.value = String(id);
    if (current) current.textContent = title;
    if (productLabel) productLabel.textContent = title;
    const selected = variants.find((button) => button.dataset.id === String(id));
    if (productImage && selected?.dataset.image) {
      productImage.src = selected.dataset.image;
      productImage.alt = `${title} Journeyman cardholder`;
    }
    if (stock) stock.textContent = available ? 'Ready to carry' : 'Currently unavailable';
    addButtons.forEach((button) => {
      button.disabled = !available;
      button.textContent = available ? (button.closest('.jm-close') ? 'Add to cart · $105.00 USD' : 'Add to cart') : 'Unavailable';
    });
  };
  variants.forEach((button) => button.addEventListener('click', () => {
    setVariant(button.dataset.id, button.dataset.title, button.dataset.available === 'true');
  }));
  if (select) select.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    setVariant(option.value, option.textContent.trim(), option.dataset.available === 'true');
  });
  const sticky = root.querySelector('[data-jm-sticky]');
  const heroPurchase = root.querySelector('[data-jm-hero] [data-jm-add]');
  if (sticky && heroPurchase) {
    const mobile = window.matchMedia('(max-width: 900px)');
    let heroVisible = true;
    const update = () => sticky.classList.toggle('is-visible', mobile.matches || !heroVisible);
    new IntersectionObserver(([entry]) => { heroVisible = entry.isIntersecting; update(); }, { threshold: 0.25 }).observe(heroPurchase);
    mobile.addEventListener('change', update);
    update();
  }
  addButtons.forEach((button) => button.addEventListener('click', async () => {
    const id = root.dataset.variantId;
    const status = root.querySelector('[data-jm-status]');
    if (!id || root.dataset.preview === 'true') {
      window.location.href = 'https://rarely.co/products/journeyman-tanner-goods';
      return;
    }
    addButtons.forEach((item) => { item.disabled = true; item.textContent = 'Adding…'; });
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) });
      if (!response.ok) throw new Error('Unable to add');
      addButtons.forEach((item) => { item.textContent = 'Added'; });
      if (status) status.textContent = 'Added to your cart.';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (error) {
      addButtons.forEach((item) => { item.textContent = 'Try again'; });
      if (status) status.textContent = 'We could not add the cardholder. Please try again.';
    } finally {
      window.setTimeout(() => {
        const selected = variants.find((item) => item.dataset.id === String(root.dataset.variantId));
        const option = select?.selectedOptions[0];
        setVariant(root.dataset.variantId, selected?.dataset.title || option?.textContent || '', selected ? selected.dataset.available === 'true' : option?.dataset.available === 'true');
      }, 1800);
    }
  }));
})();
